export class DocumentoEntidade {
  public OID_DOCUMENTO: number;
  public OID_ARQUIVO_UPLOAD: number;
  public OID_DOCUMENTO_PASTA?: number;
  public TXT_TITULO: string;
  public IND_ATIVO: string;
  public DTA_INCLUSAO: Date;
  public CD_PLANO: string;
  public DS_PLANO: string;
}
